{
  "ar-EG": "ar",
  "az-AZ": "az",
  "en-IN": "enIndian",
  "en-GB": "uk",
  "en-US": "en",
  "eo": "eo",
  "es-ES": "es",
  "fr-FR": "fr",
  "id-ID": "id",
  "pt-BR": "pt",
  "pt-PT": "ptPT",
  "ru-RU": "ru",
  "tr-TR": "tr",
  "vi-VN": "vi"
}